export default __webpack_public_path__ + "static/media/1.68f985e0.jpg";